var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.895 11.2992C49.5467 14.9986 48.5012 20.2554 45.8972 24.7971C43.3004 29.3187 39.1185 33.1384 35.3261 32.9883C31.5338 32.8381 28.131 28.7182 25.2135 24.9529C22.2888 21.2079 19.8494 17.8176 20.2617 14.7638C20.6739 11.7101 23.9308 9.01316 27.3044 7.1524C30.6659 5.26458 34.1491 4.26016 38.0519 4.83562C41.9547 5.41108 46.2698 7.58655 47.895 11.2992Z",
    fill: "#E7CCA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 36C2 30.3432 2 27.5148 3.75736 25.7574C5.51472 24 8.34314 24 14 24H30C35.6568 24 38.4852 24 40.2426 25.7574C42 27.5148 42 30.3432 42 36C42 41.6568 42 44.4852 40.2426 46.2426C38.4852 48 35.6568 48 30 48H14C8.34314 48 5.51472 48 3.75736 46.2426C2 44.4852 2 41.6568 2 36Z",
    stroke: "#01342C",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.998 40C24.2072 40 25.998 38.2091 25.998 36C25.998 33.7909 24.2072 32 21.998 32C19.7889 32 17.998 33.7909 17.998 36C17.998 38.2091 19.7889 40 21.998 40Z",
    stroke: "#01342C",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24V20C10 13.3726 15.3726 8 22 8C28.6274 8 34 13.3726 34 20V24",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlob);
export default __webpack_public_path__ + "static/media/lock-blob.e35c58de24afaaada009524f11b616ef.svg";
export { ForwardRef as ReactComponent };